<template>
    <div id="app" :page="setPageName()">
        <TopMenu/>

        <router-view :key="$route.path"></router-view>
        <ForecastRunnerStatus></ForecastRunnerStatus>

        <div class="modal show" v-if="$store.state.error.show" v-on:click="onCloseError()">
            <div class="modal-content">
                <header>{{ $store.state.error.data.type }} <span title="Close"></span></header>
                <article>
                    <template v-if="$store.state.error.data.hasError">
                        <div class="validation-error">
                            <div
                                v-for="item in $store.state.error.message.errors">
                                <h4>{{ item.text }}</h4>
                                <ul>
                                    <li v-for="error in item.errors">
                                        {{ error.text }}
                                        <HelperBox v-if="error.helper" :text="error.helper"></HelperBox>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <ul v-if="hasErrorArray()">
                            <li v-for="message in this.$store.state.error.data.message">
                                {{ message }}
                            </li>
                        </ul>
                        <div v-else-if="hasInnerErrorArray() || singleErrorMessage()"  class="validation-error">
                            <template v-if="singleErrorMessage()">
                                <p>
                                    <b>
                                        {{ this.$store.state.error.data.message }}
                                    </b>
                                </p>
                            </template>
                            <ul v-if="hasInnerErrorArray()">
                                <template v-for="message in this.$store.state.error.data.data.messages">
                                    <li v-if="message">
                                       {{ message }}
                                    </li>
                                </template>
                            </ul>
                        </div>                                                
                    </template>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    import TopMenu from "./Js/Components/TopMenu.vue"
    import HelperBox from "./Js/Components/HelperBox.vue"
    import ForecastRunnerStatus from "./Js/Components/ForecastRunnerStatus.vue"
    

    export default {
        components: {
            TopMenu,
            ForecastRunnerStatus,
            HelperBox
        },
        name: "app",
        mounted ()  {
            this.setPageName();
        },
        methods: {
            onCloseError(e) {
                this.$store.state.error.show = false;
                this.$store.state.error.data = {};
                console.log("OnClose error: " + e);
            },           
            hasErrorArray: function () {
              
                if (this.NullOrUndefined(this.$store.state.error.data))
                {
                  return false;
                }

              if (this.NullOrUndefined(this.$store.state.error.data.message))
              {
                return false;
              }
                
               

                return Array.isArray(this.$store.state.error.data.messages);

                
            },            
            singleErrorMessage: function () {
              if (this.NullOrUndefined(this.$store.state.error.data))
              {
                return false;
              }

              if (this.NullOrUndefined(this.$store.state.error.data.message))
              {
                return false;
              }
              
                
                return this.$store.state.error.data.message !== "";

                
            },
            hasInnerErrorArray: function () {
                if (this.NullOrUndefined(this.$store.state.error.data.data)) {
                    return false;
                }

                if (this.NullOrUndefined(this.$store.state.error.data.data.messages)) {
                    return false;
                }

                return Array.isArray(this.$store.state.error.data.data.messages);

                
            },
            setPageName(){
                let className = "";
                if(this.$route.name.indexOf("studyEditor") !== -1 || this.$route.name.indexOf("studyAggregator") !== -1)
                    className = "editor";
                else
                    className = this.$route.name;

                document.getElementsByTagName("html")[0].className = "";
                document.getElementsByTagName("html")[0].classList.add("page-" + className);

                return className;
            }
        }
    }
</script>